import TrainIcon from '@mui/icons-material/Train';
import React from 'react';
import { useParams } from 'react-router';
import { TrainCoursesSection } from '../../components/TrainCoursesSection';
export const widgetAccountTrainCoursesType = 'credentialing.accountTrainCourses';
const WidgetAccountTrainCourses = (props) => {
    const { accountId } = useParams();
    if (!accountId)
        return null;
    const formParams = props.rootParams.formParams;
    if (!formParams) {
        return null;
    }
    const { esarVhpCode, showTrainIntegrationFields } = formParams;
    if (!showTrainIntegrationFields) {
        return null;
    }
    return React.createElement(TrainCoursesSection, { clientCode: esarVhpCode, accountId: accountId });
};
export const widgetAccountTrainCourse = {
    type: widgetAccountTrainCoursesType,
    component: WidgetAccountTrainCourses,
    createWidget: () => ({
        type: widgetAccountTrainCoursesType,
        key: 'accountTrainCourses',
    }),
    icon: React.createElement(TrainIcon, { fontSize: 'small' }),
};
